<template>
  <div class="provide-page">
    <div class="filter-row">
      <el-select
        v-model="time_type"
        style="width: 90px"
        @change="handleTimeTypeChange"
      >
        <el-option :value="1" label="日报"></el-option>
        <el-option :value="2" label="月报"></el-option>
      </el-select>

      <el-date-picker
        v-if="time_type === 1"
        v-model="time_range"
        type="daterange"
        range-separator="—"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 300px; margin-left: 10px"
        clearable
      />

      <el-date-picker
        v-else
        v-model="time_range"
        type="monthrange"
        range-separator="—"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        value-format="yyyy-MM"
        style="width: 300px; margin-left: 10px"
        clearable
      />

      <el-button type="primary" style="margin-left: 16px" @click="onSearch"
        >搜索</el-button
      >
      <el-button style="margin-left: 10px" @click="onReset">重置</el-button>
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="onExport"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('2166') : false
        "
        >导出</el-button
      >
    </div>

    <div class="count-card-wrap">
      <div class="count-card" v-for="item in countItems" :key="item.key">
        <div class="count-label">{{ item.label }}</div>
        <div class="count-value">{{ count_data[item.key] || 0 }}</div>
      </div>
    </div>

    <div class="table-wrap">
      <el-table :data="list" border style="width: 100%">
        <el-table-column
          :label="time_type === 1 ? '日期' : '月份'"
          min-width="120"
          fixed="left"
        >
          <template slot-scope="{ row }">
            {{ row.date || "--" }}
          </template>
        </el-table-column>

        <el-table-column
          v-for="item in countItems"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          min-width="130"
        ></el-table-column>
      </el-table>
    </div>

    <Pagination
      v-if="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="limit"
      @pagination="onPagination"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import integralmanageApi from "@/api/integralmanage";
import Pagination from "@/components/Pagination/index.vue";

const COUNT_ITEMS = [
  { key: "total", label: "发放总数" },
  { key: "share_doctor", label: "分享医生赠送" },
  { key: "share_goods", label: "分享商品赠送" },
  { key: "share_friend", label: "邀请好友赠送" },
  { key: "share_content", label: "分享科普内容赠送" },
  { key: "goods_eva", label: "商品评价赠送" },
  { key: "check_in_day", label: "每日签到赠送" },
  { key: "check_in_reward", label: "连续签到赠送" },
  { key: "share_evaluation", label: "分享测评赠送" },
  { key: "consult", label: "问诊赠送" },
  { key: "prescription", label: "处方订单赠送" },
  { key: "refund", label: "消费退还" },
  { key: "health_card", label: "歧黄养生卡赠送" },
  { key: "inquiry", label: "随访评价赠送" },
  { key: "shop", label: "商城订单赠送" },
  { key: "birthday", label: "生日赠送" },
  { key: "compensation", label: "补偿赠送" },
  { key: "festival", label: "节日赠送" },
];

export default {
  name: "ProvidePage",
  components: {
    Pagination,
  },
  data() {
    const endDay = dayjs().format("YYYY-MM-DD");
    const startDay = dayjs().subtract(30, "day").format("YYYY-MM-DD");
    return {
      time_type: 1,
      time_range: [startDay, endDay],
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      count_data: {},
      countItems: COUNT_ITEMS,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  activated() {
    this.getList();
  },
  methods: {
    getListParams() {
      const [start_time, end_time] = this.time_range || [];
      return {
        time_type: this.time_type,
        start_time: start_time || "",
        end_time: end_time || "",
        page: this.page,
        pageNumber: this.limit,
        limit: this.limit,
      };
    },
    getExportParams() {
      const [start_time, end_time] = this.time_range || [];
      return {
        time_type: this.time_type,
        start_time: start_time || "",
        end_time: end_time || "",
      };
    },
    getList() {
      const params = this.getListParams();
      integralmanageApi.getIntegralIssueList(params).then((res) => {
        if (res.code === 0) {
          const data = res.data || {};
          this.list = data.list || [];
          this.count_data = data.count_data || {};
          this.total = Number(data.total || 0);
        }
      });
    },
    handleTimeTypeChange() {
      this.time_range = [];
      this.page = 1;
      this.getList();
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    onReset() {
      this.time_type = 1;
      const endDay = dayjs().format("YYYY-MM-DD");
      const startDay = dayjs().subtract(30, "day").format("YYYY-MM-DD");
      this.time_range = [startDay, endDay];
      this.page = 1;
      this.limit = 10;
      this.getList();
    },
    onPagination({ page, limit }) {
      this.page = page;
      this.limit = limit;
      this.getList();
    },
    onExport() {
      const loading = this.$loading();
      const params = this.getExportParams();
      integralmanageApi
        .exportIntegralIssueList(params)
        .then((res) => {
          if (res.code === 0) {
            const host =
              document.location.protocol +
              "//" +
              window.location.host +
              (res.data && res.data.url ? res.data.url : "");
            if (res.data && res.data.url) {
              window.open(host);
            }
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.provide-page {
  .filter-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .count-card-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  .count-card {
    width: 126px;
    height: 72px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 6px;

    .count-label {
      color: #303133;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }

    .count-value {
      margin-top: 6px;
      color: #303133;
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
    }
  }

  .table-wrap {
    width: 100%;
    overflow-x: auto;
  }
}
</style>
